import React, { useMemo } from 'react';
import { Search, ExternalLink } from 'lucide-react';

const FIELDS = [
  { key: 'utm_source', label: 'Source', valueCls: 'font-medium text-earth-dark' },
  { key: 'utm_medium', label: 'Medium', valueCls: 'font-medium text-earth-dark' },
  { key: 'utm_campaign', label: 'Campaign', valueCls: 'font-medium text-earth-dark' },
  { key: 'utm_term', label: 'Keyword', valueCls: 'font-bold text-blue-700' },
  { key: 'referrer', label: 'Referrer', wide: true, link: true, valueCls: 'text-earth/70 truncate flex items-center gap-1' },
  { key: 'landing_page', label: 'Landing Page', wide: true, valueCls: 'text-earth/70 truncate' },
];

export default function AttributionPanel({ attribution }) {
  const visibleFields = useMemo(() => FIELDS.filter(f => attribution?.[f.key]), [attribution]);
  if (visibleFields.length === 0) return null;
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3 mb-4" data-testid="attribution-panel">
      <p className="text-[10px] uppercase tracking-wider text-blue-700/60 font-sans font-semibold mb-2 flex items-center gap-1"><Search size={10} /> Lead Source / Attribution</p>
      <div className="grid grid-cols-2 gap-2">
        {visibleFields.map(f => (
          <div key={f.key} className={`bg-white/70 rounded px-2 py-1.5 ${f.wide ? 'col-span-2' : ''}`} data-testid={`attribution-${f.key}`}>
            <p className="text-[9px] uppercase text-blue-400 font-sans font-semibold">{f.label}</p>
            <p className={`text-xs font-sans ${f.valueCls}`}>{f.link && <ExternalLink size={9} />} {attribution[f.key]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
